"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jquery_1 = __importDefault(require("jquery"));
const lodash_1 = __importDefault(require("lodash"));
class ColumnFilterPlugin {
    constructor(table, settings, options) {
        this.table = table;
        this.settings = settings;
        this.options = options;
        this.isInitialized = false;
        this.initFilters = (dataTable, options, removePreviousFilterElementsOnUpdate) => {
            this.attachFilterInputs(removePreviousFilterElementsOnUpdate);
            this.restoreFilterValues(dataTable);
            if (!options.serverSide) {
                this.enableFilterInputs(dataTable);
            }
            else {
                this.enableServerFilterInputs(dataTable);
            }
        };
        this.restoreFilterValues = (dataTable) => {
            const initSettings = dataTable.settings()[0];
            // write filter values into filter input fields (in case of stateLoad or filter preset)
            const urlParams = location.search ? new URLSearchParams(location.search) : undefined;
            for (let i = 0; i < initSettings.aoPreSearchCols.length; i++) {
                let filterValue = initSettings.aoPreSearchCols[i].sSearch;
                if (urlParams) {
                    const c = initSettings.aoColumns[i];
                    if (c && c.data) {
                        const s = urlParams.get(`${initSettings.sInstance}[${c.data}]`) || "";
                        if (s !== (filterValue || "")) {
                            filterValue = s;
                            dataTable
                                .column(i)
                                .search(filterValue);
                        }
                    }
                }
                const $h = (0, jquery_1.default)(dataTable.column(i).header());
                const idx = $h.index();
                if (idx > -1) {
                    (0, jquery_1.default)(this.table.find("thead tr.filters th")[idx])
                        .find("input,select").each(function () {
                        if ((0, jquery_1.default)(this).is("select") && filterValue.substr(0, 1) === "=") {
                            (0, jquery_1.default)(this).val(filterValue.substr(1));
                        }
                        else {
                            (0, jquery_1.default)(this).val(filterValue);
                        }
                    });
                }
            }
        };
        this.attachFilterInputs = (removePreviousFilterElements = false) => {
            const $table = this.table;
            if (removePreviousFilterElements) {
                $table.find("thead tr.filters").remove();
            }
            const { options, settings } = this;
            const $filters = (0, jquery_1.default)("<tr />").attr("class", "filters smart-form");
            const $dataTable = (0, jquery_1.default)($table).data("dataTable");
            const columns = options.columns.filter((column, index) => $table.DataTable().column(index).visible() && column);
            let searchableColumns = 0;
            $table.find('thead tr th:not([colspan]), thead tr th[colspan="1"]').each(function (index) {
                const column = columns[index] || undefined;
                const $col = (0, jquery_1.default)(this);
                const $colHead = (0, jquery_1.default)("<th />")
                    .attr("class", "hasinput")
                    .attr("data-hide", $col.data("hide"))
                    .attr("data-filter-type", $col.data("filter-type"))
                    .data("column-index", index);
                if ($col.hasClass("hidden")) {
                    $colHead.addClass("hidden");
                }
                if ($col.data("filter-type") === "none" || (column && column.searchable === false)) {
                    $filters.append($colHead);
                    return;
                }
                searchableColumns++;
                switch ($col.data("filter-type") || (column && column["filter-type"])) {
                    case "select": // 2nd Data Request "Unique Values"
                        $filters.append($colHead.append((0, jquery_1.default)("<label />")
                            .attr("class", "select")
                            .append((0, jquery_1.default)('<select><option value="">Filter</option></select><i></i>'))));
                        break;
                    case "list": {
                        // TODO: Support Multi
                        const select = (0, jquery_1.default)('<select><option value="">Filter</option></select>');
                        jquery_1.default.each(column.render.options || {}, (value, label) => {
                            select.append((0, jquery_1.default)("<option />")
                                .attr("value", value)
                                .text(label));
                        });
                        $filters.append($colHead.append((0, jquery_1.default)("<label />")
                            .attr("class", "select")
                            .append(select)
                            .append("<i></i>")));
                        break;
                    }
                    case "simple":
                        $filters.append($colHead.append((0, jquery_1.default)("<label />")
                            .attr("class", "input")
                            .append((0, jquery_1.default)("<input />").attr({
                            type: "text",
                            class: "form-control",
                            placeholder: $dataTable.i18n("filter.simple.placeholder", settings.filter.simple.placeholder)
                        }))
                            .append((0, jquery_1.default)("<b />")
                            .attr("class", "tooltip tooltip-bottom-left")
                            .text($dataTable.i18n("filter.simple.tooltip", settings.filter.simple.tooltip)))));
                        break;
                    case "date":
                        $filters.append($colHead.append((0, jquery_1.default)("<label />")
                            .attr("class", "input")
                            .append((0, jquery_1.default)("<input />").attr({
                            type: "text",
                            class: "datepicker",
                            placeholder: $dataTable.i18n("filter.placeholder", settings.filter.placeholder)
                        }))));
                        break;
                    case "text":
                    default:
                        $filters.append($colHead.append((0, jquery_1.default)("<label />")
                            .attr("class", "input")
                            .append((0, jquery_1.default)("<input />").attr({
                            type: "text",
                            class: "form-control",
                            placeholder: $dataTable.i18n("filter.placeholder", settings.filter.placeholder)
                        }))
                            .append((0, jquery_1.default)("<b />")
                            .attr("class", "tooltip tooltip-bottom-left")
                            .text($dataTable.i18n("filter.tooltip", settings.filter.tooltip)))));
                }
            });
            if (searchableColumns) {
                $table.find("thead").prepend($filters);
            }
        };
        this.enableFilterInputs = (dataTable) => {
            const $table = (0, jquery_1.default)(dataTable.table().node());
            dataTable
                .columns()
                .indexes()
                .flatten()
                .each((i) => {
                const column = dataTable.column(i);
                if ((0, jquery_1.default)(column.header()).data("filter-type") === "select") {
                    const $column = (0, jquery_1.default)(column.header());
                    const $select = (0, jquery_1.default)($column
                        .parent()
                        .parent()
                        .find("tr.filters th")
                        .get(i));
                    column
                        .data()
                        .unique()
                        .sort()
                        .each((d) => {
                        $select
                            .find("select")
                            .append(`<option value="${d}">${d}</option>`);
                    });
                }
            });
            const debounced = lodash_1.default.debounce(dataTable.draw, this.settings.filter.throttle);
            $table
                .find("thead th input[type=text], thead th select")
                .on("keyup change", debounced);
        };
        this.enableServerFilterInputs = (dataTable) => {
            const $table = (0, jquery_1.default)(dataTable.table().node());
            const { settings } = this;
            const selectColumns = [];
            const columnKeys = [];
            dataTable
                .columns()
                .indexes()
                .flatten()
                .each((i) => {
                const column = dataTable.column(i);
                if ((0, jquery_1.default)(column.header()).data("filter-type") === "select") {
                    selectColumns.push(i);
                    columnKeys.push({
                        data: column.dataSrc()
                    });
                }
            });
            if (selectColumns.length) {
                jquery_1.default.ajax(jquery_1.default.extend({
                    url: null,
                    type: "get",
                    data: {
                        request: "unique_values",
                        columns: columnKeys
                    },
                    dataType: "json",
                    success(response) {
                        selectColumns.forEach((index) => {
                            const column = dataTable.column(index);
                            // strip dot escaping slashes that do not get returned from server side.
                            const dataSrc = column
                                .dataSrc()
                                .replace(/\\/g, "");
                            if (typeof response.options[dataSrc]
                                !== "undefined") {
                                const $select = (0, jquery_1.default)((0, jquery_1.default)(column.header())
                                    .parent()
                                    .parent()
                                    .find("tr.filters th")
                                    .get(index)).find("select");
                                response.options[dataSrc].forEach((option) => {
                                    let value = option;
                                    let label = option;
                                    if (typeof option === "object") {
                                        ({ value, label } = option);
                                    }
                                    if (typeof $table.data("options")
                                        .columns[index].render
                                        === "function") {
                                        label = $table
                                            .data("options")
                                            .columns[index].render(label, null, null);
                                    }
                                    $select.append(`<option value="=${value}">${label}</option>`);
                                });
                                // write filter value into filter select field
                                // (in case of stateLoad or filter preset)
                                const filterValue = dataTable.settings()[0].aoPreSearchCols[index].sSearch;
                                if (filterValue) {
                                    $select.val(`=${filterValue}`);
                                }
                            }
                        });
                    }
                }, $table.data("options").ajax || {}));
            }
            const debounced = lodash_1.default.debounce(() => {
                dataTable.draw();
            }, settings.filter.throttle);
            const changeFilters = function () {
                let value = (0, jquery_1.default)(this).val();
                const index = (0, jquery_1.default)(this)
                    .closest("th")
                    .data("column-index");
                if (value) {
                    const filterType = (0, jquery_1.default)(this)
                        .closest("th")
                        .attr("data-filter-type") || $table.data("options").columns[index]["filter-type"];
                    switch (filterType) {
                        case "simple":
                            value = `^${value}`;
                            break;
                        case "equal":
                        case "list":
                            value = `=${value}`;
                            break;
                        default:
                    }
                }
                dataTable
                    .column(`${(0, jquery_1.default)(this)
                    .closest("th")
                    .index()}:visible`)
                    .search(value);
                debounced();
            };
            $table.find("thead th input[type=text]").on("keyup", changeFilters);
            $table.find("thead th input[type=text]").on("change", changeFilters);
            $table.find("thead th select").on("change", changeFilters);
        };
    }
    init(dataTable) {
        const { options } = this;
        dataTable.on("init.dt", () => {
            this.isInitialized = true;
        });
        if (options.hideFilters === undefined || options.hideFilters !== true) {
            dataTable.on("preInit.dt", () => this.initFilters(dataTable, options, false));
            dataTable.on("column-visibility.dt", () => this.isInitialized && this.initFilters(dataTable, options, true));
        }
    }
}
exports.default = ColumnFilterPlugin;
